<template>
  <div>
    <h2>Referrals</h2>
    <v-progress-circular indeterminate color="info" v-if="!referralDataMain" />
    <p v-if="referralDataMain">
      <router-link
        :to="{
          name: 'referrals',
          query: { year: referralDataMain.yearBefore }
        }"
        >{{ referralDataMain.yearBefore }}</router-link
      >
      <span>&#160;&lt;&#160;{{ referralDataMain.year }}&#160;&gt;&#160;</span>
      <router-link
        :to="{ name: 'referrals', query: { year: referralDataMain.yearAfter } }"
        >{{ referralDataMain.yearAfter }}</router-link
      >
    </p>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="modifiedReferralData"
      hide-actions
      class="elevation-1"
      v-if="referralDataMain"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <router-link
              :to="{ name: 'referrer', params: { id: props.item.entityid } }"
            >
              <span v-if="props.item.entity">{{ props.item.entity.name }}</span>
              <span v-if="!props.item.entity">{{ props.item.entityid }}</span>
            </router-link>
          </td>
          <td>
            <v-layout row>
              <v-flex xs12 md6 class="referralValue referralPercentage"
                >{{ props.item.instructionsPercentage }}%</v-flex
              >
              <v-flex xs12 md6 class="referralValue">{{
                props.item.instructions
              }}</v-flex>
            </v-layout>
          </td>
          <td>
            <v-layout row>
              <v-flex xs12 md6 class="referralValue referralPercentage"
                >{{ props.item.completionsPercentage }}%</v-flex
              >
              <v-flex xs12 md6 class="referralValue">{{
                props.item.completions
              }}</v-flex>
            </v-layout>
          </td>
          <td class="referralValue">{{ props.item.total | toCurrency }}</td>
          <td class="referralValue">{{ props.item.average | toCurrency }}</td>
        </tr>
      </template>
      <template slot="footer">
        <td />
        <td class="referralValue">{{ referralDataMain.totalInstructions }}</td>
        <td class="referralValue">{{ referralDataMain.totalCompletions }}</td>
        <td class="referralValue">
          {{ referralDataMain.totalSales | toCurrency }}
        </td>
        <td />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import { convertListOfObjectsToMap } from "@/util/helpers";
export default {
  name: "Referrals",
  metaInfo() {
    return {
      title: "Referrals",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    modifiedReferralData() {
      if (!this.referralDataMain || !this.referralDataMain.referralData) {
        return undefined;
      }
      const entityMap = this.entities
        ? convertListOfObjectsToMap(this.entities, "id")
        : undefined;
      return this.referralDataMain.referralData.map((rd) => {
        const entity = entityMap ? entityMap[rd.entityid] : undefined;
        return {
          ...rd,
          entity
        };
      });
    }
  },
  data() {
    return {
      referralDataMain: null,
      entities: null,
      headers: [
        {
          text: "Referrer",
          value: "entity.name"
        },
        {
          text: "Instructions",
          value: "instructions"
        },
        {
          text: "Completions",
          value: "completions"
        },
        {
          text: "Sales",
          value: "total"
        },
        {
          text: "Avg",
          value: "average"
        }
      ],
      pagination: {
        sortBy: "total",
        descending: true,
        page: 1,
        rowsPerPage: -1
      }
    };
  },
  methods: {
    async fetchReferralDataMain() {
      const response = await nbmlaw.get("/cors/admin/sales/referrals", {
        params: { year: this.$route.query.year }
      });
      // console.log(response.data);
      this.referralDataMain = response.data;
    },
    async fetchReferrers() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/types/13/entities`
      );
      // console.log(response.data);
      this.entities = response.data;
    }
  },
  watch: {
    "$route.query.year": {
      immediate: true,
      handler() {
        this.fetchReferralDataMain();
      }
    }
  },
  created() {
    this.fetchReferrers();
  }
};
</script>

<style scoped>
.referralValue {
  text-align: right;
}

.referralPercentage {
  font-size: 0.8em;
  color: green;
}
</style>
